import React from 'react';
import './page-title.css';
import './user-frontend-page-title.css';
import {currentStack} from '../../../data/stack';

const PageTitle = ({
  pageTitle, articleTitle, children, ignoreForDoc
}) => {
  let pTitle = '';

  if (articleTitle !== undefined) {
    pTitle = `${articleTitle} - ${children}`;
  } else if (pageTitle !== undefined) {
    pTitle = `${pageTitle}`;
  } else if (children !== undefined) {
    pTitle = `${children}`;
  }

  if (!ignoreForDoc) {
    document.title = `Ignite ${currentStack} – ${pTitle}`;
  }

  return children ? (
    <div className="page-title">
      <h1 className="text-uppercase">
        {children}
      </h1>
    </div>
  )
    : null;
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/common/page-title/index.jsx